import {PaymentFileValidationLazy} from 'app/components/paymentFileValidation/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function definePaymentFileValidation(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-payment-file-validation')) {
        return;
    }

    customElements.define(
        'gem-payment-file-validation',
        class extends WebComponentLoader {
            reactLazyComponent = PaymentFileValidationLazy;
        },
    );
}
